const appConfig = {
    appId: "dataQore-3006cdcd-0b01-4973-867e-1195ce1ab582",
    appName: "Data",
    site: 'data-qore',
    icon: "https://nsdstaticasset.blob.core.windows.net/assets/Qore_Brand_Icons/dataQoreAppIcon.png"
};

export default appConfig;
